/**
 * Block deprecation
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

const v1 = {
  save() {
    return (
      null
    );
  }
};

export default [ v1 ];
